import React, { Component } from 'react';
import { Modal } from 'antd';

export default class Avatarpicture extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModel:false
    }
  }

  handleImgClick=(img)=>{
    if(!img) return
    this.setState({showModel:true})
  }
  handleCancel=()=>{
    this.setState({showModel:false})
  }
  render() {
    const {src, srcBig} = this.props;
    let {showModel} = this.state;
    return (
      <div>
        <Modal width={600} height={600} visible={showModel} maskClosable={false} onCancel={() => this.handleCancel()}
        className="avatar-big-modal"  >
          <div className='picture-big'>
          <img src={srcBig}/>
          </div>
        </Modal>
        <img src={src} className='cell-avatar-default' onClick={()=>this.handleImgClick(src)}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/picturebook/Avatarpicture.jsx